/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Component } from "@angular/core";
import { MatExpansionModule } from "@angular/material/expansion";

@Component({
	selector: "globalictcc-accordion-group",
	standalone: true,
	imports: [MatExpansionModule],
	templateUrl: "./accordion-group.component.html",
	styleUrl: "./accordion-group.component.scss"
})
export class AccordionGroupComponent {}
